// Kept independent of Vue/request.js to guard both HTTP and SDK actions.
let activeGuard
export function registerMeetingSessionGuard(guard) {
  activeGuard = guard
  return () => { if (activeGuard === guard) activeGuard = undefined }
}
export const hasActiveMeetingSession = () => Boolean(activeGuard?.active())
export const canUseMeetingSession = () => !hasActiveMeetingSession() || activeGuard.allowed()
export function assertMeetingSession() {
  if (canUseMeetingSession()) return
  const error = new Error('Meeting account permissions need verification.')
  error.code = 'MEETING_SESSION_RECHECK'
  error.isSessionBlocked = true
  throw error
}
